module.exports = __webpack_public_path__ + "img/My admin.12dfcc63.svg";